/* Lovu bold layer, 20/10/2026: systems tabs + pack picker. No dependencies. 03/11/2026 v11.6: Arabic pages get Arabic hint/label strings. */
(function () {
  'use strict';
  function money(n) { var f = window.lxMoneyFormat || 'AED {{amount}}'; var s = (Math.round(n * 100) / 100).toFixed(2); if (s.slice(-3) === '.00') s = s.slice(0, -3); return f.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, ''); }
  /* tabs */
  document.querySelectorAll('[data-lb-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-lb-tab]'); var panels = root.querySelectorAll('[data-lb-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-lb-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-on', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        panels.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-lb-panel') === id); });
      });
    });
  });
  /* pack picker */
  document.querySelectorAll('[data-lb-pack]').forEach(function (root) {
    var packs = []; try { packs = JSON.parse(root.getAttribute('data-lb-pack')); } catch (e) { return; }
    var state = { id: root.getAttribute('data-lb-default') || packs[0].id, sub: false };
    var form = root.querySelector('form'); var idIn = form.querySelector('[name="id"]'); var qtyIn = form.querySelector('[name="quantity"]'); var planIn = form.querySelector('[name="selling_plan"]');
    var priceEl = root.querySelector('[data-lb-price]'); var perEl = root.querySelector('[data-lb-perday]'); var btnEl = root.querySelector('[data-lb-btn]'); var togs = root.querySelectorAll('[data-lb-sub]'); var rows = root.querySelectorAll('[data-lb-row]');
    function cur() { for (var i = 0; i < packs.length; i++) if (packs[i].id === state.id) return packs[i]; return packs[0]; }
    function render() {
      var p = cur(); var hasPlan = !!p.plan; var useSub = state.sub && hasPlan; var unit = useSub ? p.subPrice : p.price;
      idIn.value = p.variant; qtyIn.value = p.qty || 1; if (planIn) { planIn.value = useSub ? p.plan : ''; planIn.disabled = !useSub; }
      priceEl.textContent = money(unit);
      var ar = (document.documentElement.lang || '').slice(0, 2) === 'ar'; perEl.textContent = money(unit / ((p.jars || 1) * 30)) + (ar ? ' باليوم' : ' a day') + (useSub ? (ar ? '، توصيل متكرر' : ', delivered on repeat') : '');
      btnEl.textContent = (root.getAttribute('data-lb-btn-label') || 'Add to bag') + ' · ' + money(unit);
      rows.forEach(function (r) { var rp = null; for (var i = 0; i < packs.length; i++) if (packs[i].id === r.getAttribute('data-lb-row')) rp = packs[i]; var on = r.getAttribute('data-lb-row') === state.id; r.classList.toggle('is-on', on); r.setAttribute('aria-pressed', on ? 'true' : 'false'); var pr = r.querySelector('.pr'); if (pr && rp) pr.textContent = money((state.sub && rp.plan) ? rp.subPrice : rp.price); });
      togs.forEach(function (t) { t.classList.toggle('is-on', (t.getAttribute('data-lb-sub') === '1') === state.sub); });
    }
    rows.forEach(function (r) { r.addEventListener('click', function () { state.id = r.getAttribute('data-lb-row'); render(); }); });
    togs.forEach(function (t) { t.addEventListener('click', function () { state.sub = t.getAttribute('data-lb-sub') === '1'; render(); }); });
    render();
  });
})();
/* PASS 2 20/10/2026: feed videos play muted while on screen, pause off screen. */
(function(){
  var vids=document.querySelectorAll('.lx-vids--feed:not(.lx-vids--tap) video');
  if(!vids.length||!('IntersectionObserver' in window))return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
    if(e.isIntersecting){if(v.preload==='none')v.preload='auto';var p=v.play();if(p&&p.catch)p.catch(function(){});}
    else{v.pause();}
  });},{threshold:.4});
  vids.forEach(function(v){v.muted=true;v.setAttribute('muted','');v.setAttribute('playsinline','');io.observe(v);});
})();
/* 21/10/2026: pack card image flip (arrows, dots, swipe). */
(function(){
  function go(f,dir){var sl=f.querySelectorAll('.lb-flip__s'),dots=f.querySelectorAll('.lb-flip__dots i'),n=sl.length,cur=0;
    for(var i=0;i<n;i++)if(sl[i].classList.contains('is-on'))cur=i;
    var nx=(cur+dir+n)%n;
    for(var j=0;j<n;j++){var on=j===nx;sl[j].classList.toggle('is-on',on);sl[j].setAttribute('aria-hidden',on?'false':'true');sl[j].tabIndex=on?0:-1;if(dots[j])dots[j].classList.toggle('is-on',on);}}
  document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('[data-lb-flip-btn]');if(!b)return;e.preventDefault();var f=b.closest('[data-lb-flip]');if(f)go(f,parseInt(b.getAttribute('data-lb-flip-btn'),10)||1);});
  document.querySelectorAll('[data-lb-flip]').forEach(function(f){var x0=null,y0=null;
    f.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY;},{passive:true});
    f.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))go(f,dx<0?1:-1);x0=null;},{passive:true});});
})();
/* 21/10/2026: on touch screens a tap on the pack image switches it instead of opening the product. */
(function(){
  var touch=window.matchMedia&&window.matchMedia('(hover: none), (pointer: coarse)');
  document.addEventListener('click',function(e){
    if(!touch||!touch.matches)return;
    var s=e.target.closest&&e.target.closest('.lb-flip__s');if(!s)return;
    var f=s.closest('[data-lb-flip]');if(!f)return;
    e.preventDefault();
    var nx=f.querySelector('.lb-flip__btn--next');if(nx)nx.click();
  });
})();

/* Lovu 21/10/2026: PDP thumbnail rail follows the main image. When the active thumb changes (swipe, dot, click),
   scroll only the rail (never the page) so the active thumb is fully in view. Works for the vertical desktop rail and the phone row. */
(function(){
  function follow(rail){
    var a = rail.querySelector('.lx-gal__thumb.is-on');
    if (!a) return;
    var r = rail.getBoundingClientRect(), b = a.getBoundingClientRect();
    if (rail.scrollWidth > rail.clientWidth + 2) {
      if (b.left < r.left) rail.scrollBy({ left: b.left - r.left, behavior: 'smooth' });
      else if (b.right > r.right) rail.scrollBy({ left: b.right - r.right, behavior: 'smooth' });
    } else if (rail.scrollHeight > rail.clientHeight + 2) {
      if (b.top < r.top) rail.scrollBy({ top: b.top - r.top, behavior: 'smooth' });
      else if (b.bottom > r.bottom) rail.scrollBy({ top: b.bottom - r.bottom, behavior: 'smooth' });
    }
  }
  function init(){
    document.querySelectorAll('.lx-gal__thumbs').forEach(function(rail){
      if (rail.__lbFollow) return; rail.__lbFollow = true;
      new MutationObserver(function(){ follow(rail); }).observe(rail, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Lovu 21/10/2026: product page preselects a pack from the URL so outside links land on the right option.
   ?selling_plan=<id> picks that subscription tier; ?pack=1|2|3 picks that jar tier. */
(function(){
  function pick(){
    var q = new URLSearchParams(location.search), sp = q.get('selling_plan'), pk = q.get('pack');
    if (!sp && !pk) return;
    var el = sp ? document.querySelector('[data-lx-tiers] input[data-plan="' + sp + '"]')
                : document.querySelector('[data-lx-tiers] input[value="' + pk + '"]');
    var lab = el && el.closest('label');
    if (lab && !lab.classList.contains('is-on')) lab.click();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(pick, 0); });
  else setTimeout(pick, 0);
})();

/* 22/10/2026: tap-to-play video feeds (home): the play button or a tap on the video plays it WITH sound;
   lx.js toggles play/pause first, this only turns the sound on when the video is now playing. */
(function(){
  document.addEventListener('click',function(e){
    var w=e.target.closest&&e.target.closest('.lx-vids--tap .lx-vid');if(!w||e.target.closest('.lx-vid__btn'))return;
    var v=w.querySelector('video'),m=w.querySelector('.lx-vid__btn');if(!v||v.paused)return;
    v.muted=false;if(m){m.setAttribute('aria-pressed','true');}
  });
})();

/* 22/10/2026: Judge.me review dates in UAE style: 10/21/2026 -> 21 Oct 2026 (the widget prints US month/day/year). */
(function(){
  var M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function fix(root){
    var els=(root||document).querySelectorAll('.jdgm-widget .jm-text, .jdgm-widget .jdgm-rev__timestamp');
    for(var i=0;i<els.length;i++){var e=els[i];if(e.childElementCount)continue;var m=/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(e.textContent.trim());if(m&&+m[1]<=12)e.textContent=(+m[2])+' '+M[+m[1]-1]+' '+m[3];}
  }
  function init(){var w=document.querySelectorAll('.jdgm-widget');if(!w.length)return;fix();for(var i=0;i<w.length;i++)new MutationObserver(function(){fix();}).observe(w[i],{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* 22/10/2026: faster site videos. Shopify serves the 1080p file (10-49 MB) by default; phones get the 480p file
   (2-11 MB), desktop the 720p one. Videos start loading one screen before they scroll into view. */
(function(){
  var vids=document.querySelectorAll('.lx-videos video');
  if(!vids.length)return;
  var small=window.matchMedia&&window.matchMedia('(max-width: 899px)').matches;
  var rep=small?'SD-480p-1.5Mbps':'HD-720p-4.5Mbps';
  vids.forEach(function(v){
    var changed=false;
    v.querySelectorAll('source').forEach(function(s){
      var u=s.getAttribute('src')||'';if(u.indexOf('.m3u8')>-1){s.remove();changed=true;return;}
      if(u.indexOf('HD-1080p-7.2Mbps')>-1){s.setAttribute('src',u.replace('HD-1080p-7.2Mbps',rep));changed=true;}
    });
    if(changed&&v.paused)v.load();
  });
  if(!('IntersectionObserver' in window))return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;var v=e.target;
    var tap=v.closest('.lx-vids--tap');
    if(!tap&&v.preload==='none')v.preload='metadata';
    io.unobserve(v);
  });},{rootMargin:'900px 0px 900px 0px'});
  vids.forEach(function(v){io.observe(v);});
})();

/* 22/10/2026: images below the fold start loading ~1.5 screens early (native lazy loading on phones waits too long,
   so the 14-actives images popped in late behind the videos). */
(function(){
  var imgs=document.querySelectorAll('main img[loading="lazy"]');
  if(!imgs.length)return;
  if(!('IntersectionObserver' in window)){imgs.forEach(function(i){i.loading='eager';});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.loading='eager';io.unobserve(e.target);}});},{rootMargin:'1400px 600px 1400px 600px'});
  var st=false;function start(){if(st)return;st=true;imgs.forEach(function(i){if(!i.closest('.lx-gal'))io.observe(i);});}if(document.readyState==='complete')start();else{window.addEventListener('load',start);['scroll','touchstart'].forEach(function(t){window.addEventListener(t,start,{passive:true,once:true});});}
})();
/* 22/10/2026: after the page has loaded, quietly fetch the images that only show on tap or swipe
   (PDP gallery slides, Skin/Hair/Nails/Daily tabs, pack-card flip images) so they never pop in late.
   Hidden Judge.me review photos are skipped (not shown on the site). */
(function(){
  /* 26/10/2026 v10.2 speed: warm ONLY images that are hidden until a tap/swipe (gallery slides, tabs, flip backs),
     and only after the visitor first scrolls or touches. Before this, every lazy image on the page loaded 1.2 s after
     load (~800 KB Google flagged as wasted, and data spent by the ~80% who leave without scrolling). */
  function warm(){
    document.querySelectorAll('main img[loading="lazy"]').forEach(function(i){
      if(i.closest('.jdgm-widget'))return;
      if(i.closest('.lx-gal')||i.offsetParent===null||i.closest('[hidden]'))i.loading='eager';
    });
  }
  var warmed=false;
  function go(){ if(warmed)return; warmed=true; ['scroll','touchstart','pointerdown','keydown'].forEach(function(t){window.removeEventListener(t,go,t!=='scroll');}); setTimeout(function(){ (window.requestIdleCallback||function(f){f();})(warm); }, 300); }
  ['scroll','touchstart','pointerdown','keydown'].forEach(function(t){window.addEventListener(t,go,{capture:t!=='scroll',passive:true});});
})();

/* 26/10/2026: links from other pages that end in #section-id (home "The science" -> product research section) land
   at the top because the browser's fragment jump is lost while the page is still laying out. Re-do the jump once
   the page has loaded, only when nothing else has scrolled yet. */
(function(){
  function jump(){
    if(!location.hash||location.hash.length<2)return;
    var el=null; try{el=document.getElementById(decodeURIComponent(location.hash.slice(1)));}catch(e){}
    if(!el||window.scrollY>40)return;
    el.scrollIntoView({block:'start',behavior:'instant'});
  }
  if(document.readyState==='complete'){setTimeout(jump,50);setTimeout(jump,700);}
  else window.addEventListener('load',function(){setTimeout(jump,50);setTimeout(jump,700);});
})();

/* 26/10/2026 (v10.1): buy-box video strip, Bold style. Muted autoplay while at least half on screen, pause when not.
   Tap the video or the speaker: sound on for that one only. Files load only when the strip nears the screen. */
(function(){
  var vids=document.querySelectorAll('.lx-ugc video');
  if(!vids.length)return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function btnOf(v){return v.parentNode.querySelector('.lx-ugc__snd');}
  function setSound(v,on){v.muted=!on;var b=btnOf(v);if(b){b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',(document.documentElement.lang||'').slice(0,2)==='ar'?(on?'اكتمي الصوت':'شغلي الصوت'):(on?'Turn sound off':'Turn sound on'));}}
  function soundOnly(v){vids.forEach(function(o){if(o!==v)setSound(o,false);});var on=v.muted;setSound(v,on);if(on&&v.paused){var p=v.play();if(p&&p.catch)p.catch(function(){});}}
  vids.forEach(function(v){
    v.muted=true;
    v.addEventListener('click',function(){soundOnly(v);});
    var b=btnOf(v);if(b)b.addEventListener('click',function(e){e.preventDefault();soundOnly(v);});
  });
  if(!('IntersectionObserver' in window)||reduce)return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
    if(e.isIntersecting&&e.intersectionRatio>=.5){if(v.preload==='none')v.preload='auto';var p=v.play();if(p&&p.catch)p.catch(function(){});}
    else{v.pause();}
  });},{threshold:[0,.5]});
  vids.forEach(function(v){io.observe(v);});
})();

/* 26/10/2026 (v10.1) MOTION #2: ADD TO BAG sends three little pink bears into the bag icon, the bag count bounces,
   the button reads "ADDED ✓" for a moment. Click-triggered only, no layout shift, off for reduced motion. */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var BEAR='<svg viewBox="0 0 40 44" width="32" height="35" aria-hidden="true"><g fill="#F59CC0"><circle cx="9" cy="8" r="6"/><circle cx="31" cy="8" r="6"/><circle cx="20" cy="15" r="11"/><ellipse cx="20" cy="32" rx="13" ry="11"/><circle cx="7" cy="29" r="5"/><circle cx="33" cy="29" r="5"/><circle cx="11" cy="40" r="5"/><circle cx="29" cy="40" r="5"/></g><g fill="#E77FAA"><circle cx="16" cy="14" r="1.4"/><circle cx="24" cy="14" r="1.4"/><ellipse cx="20" cy="18.5" rx="2.6" ry="1.8"/></g></svg>';
  function bagIcon(){var a=[].slice.call(document.querySelectorAll('[data-lx-cart-open]'));for(var i=0;i<a.length;i++){var r=a[i].getBoundingClientRect();if(r.width&&r.height&&r.top<innerHeight&&r.bottom>0)return a[i];}return null;}
  function fly(btn){
    var bag=bagIcon();if(!bag||!document.body.animate)return;
    var b=btn.getBoundingClientRect(),t=bag.getBoundingClientRect();
    var tx=t.left+t.width/2,ty=t.top+t.height/2;
    for(var i=0;i<3;i++){(function(i){
      var el=document.createElement('div');el.innerHTML=BEAR;
      el.style.cssText='position:fixed;left:0;top:0;opacity:0;z-index:2147483000;pointer-events:none;will-change:transform,opacity';
      document.body.appendChild(el);
      var sx=b.left+b.width/2+(i-1)*34-13,sy=b.top+b.height/2-14;
      var ex=tx-13,ey=ty-14,mx=(sx+ex)/2+(i-1)*40,my=Math.min(sy,ey)-120-i*20;
      var a=el.animate([
        {transform:'translate('+sx+'px,'+sy+'px) scale(.6) rotate(0deg)',opacity:0},
        {transform:'translate('+sx+'px,'+(sy-18)+'px) scale(1.05) rotate(-8deg)',opacity:1,offset:.15},
        {transform:'translate('+mx+'px,'+my+'px) scale(.95) rotate('+(i*20-20)+'deg)',opacity:1,offset:.55},
        {transform:'translate('+ex+'px,'+ey+'px) scale(.35) rotate('+(i*30)+'deg)',opacity:.2}
      ],{duration:820+i*90,delay:i*70,easing:'cubic-bezier(.45,.05,.35,1)',fill:'both'});
      a.onfinish=function(){el.remove();if(i===2)bump(bag);};
    })(i);}
  }
  function bump(bag){if(!bag.animate)return;bag.animate([{transform:'scale(1)'},{transform:'scale(1.28)'},{transform:'scale(.92)'},{transform:'scale(1)'}],{duration:420,easing:'ease-out'});}
  function added(btn){
    var drawer=document.getElementById('lx-cart');if(!drawer)return;
    var done=false,mo=new MutationObserver(function(){
      if(done||!drawer.classList.contains('is-open'))return;done=true;mo.disconnect();
      /* wait until lx.js has restored the button (disabled off, label back), then show Added */
      var tries=0,iv=setInterval(function(){
        if(++tries>60){clearInterval(iv);return;}
        if(btn.disabled||/adding/i.test(btn.textContent))return;
        clearInterval(iv);var keep=btn.innerHTML;btn.classList.add('lx-btn--added');btn.innerHTML=(document.documentElement.lang||'').slice(0,2)==='ar'?'<span>تمت الإضافة ✓</span>':'<span>Added ✓</span>';
        setTimeout(function(){btn.classList.remove('lx-btn--added');if(btn.innerHTML.indexOf('Added')>-1)btn.innerHTML=keep;},1400);
      },50);
    });
    mo.observe(drawer,{attributes:true,attributeFilter:['class']});setTimeout(function(){mo.disconnect();},6000);
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('.lx-buy .lx-pform button[type=submit][name=add]');
    if(!btn||btn.disabled)return;
    if(!reduce)fly(btn);
    added(btn);
  },true);
})();

/* 26/10/2026 (v10.1) MOTION #3: choosing a pack rewards the upgrade. The pack picture pops and the
   "You save AED …" amount rolls up from 0. Click-triggered only, off for reduced motion. */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce)return;
  function roll(el){
    /* the real text is kept in data-lb-orig, so a second tap mid-roll never locks in a half-counted number */
    if(!el.dataset.lbOrig)el.dataset.lbOrig=el.textContent;
    var orig=el.dataset.lbOrig,m=orig.match(/^(.*?)(\d[\d,]*)(.*)$/);if(!m)return;
    var to=parseInt(m[2].replace(/,/g,''),10);if(!to)return;
    var token={};el.__lbRoll=token;
    var start=performance.now(),dur=650;
    function step(now){if(el.__lbRoll!==token)return;var p=Math.min(1,(now-start)/dur),e=1-Math.pow(1-p,3);el.textContent=p<1?m[1]+Math.round(to*e).toLocaleString('en-US')+m[3]:orig;if(p<1)requestAnimationFrame(step);}
    requestAnimationFrame(step);
    /* safety net: whatever happens to animation frames, the right amount is back within a second */
    setTimeout(function(){if(el.__lbRoll===token)el.textContent=orig;},1000);
  }
  document.addEventListener('change',function(e){
    var wrap=e.target.closest&&e.target.closest('[data-lx-tiers]');if(!wrap)return;
    setTimeout(function(){
      var on=wrap.querySelector('.lx-tier.is-on');if(!on)return;
      var img=on.querySelector('.lx-tier__img');
      if(img&&img.animate)img.animate([{transform:'scale(1)'},{transform:'scale(1.12) rotate(-3deg)'},{transform:'scale(.97) rotate(1deg)'},{transform:'scale(1)'}],{duration:480,easing:'cubic-bezier(.3,1.4,.5,1)'});
      var sv=on.querySelector('small');if(sv&&/save/i.test(sv.textContent))roll(sv);
      if(on.animate)on.animate([{boxShadow:'0 0 0 0 rgba(61,10,46,.22)'},{boxShadow:'0 0 0 8px rgba(61,10,46,0)'}],{duration:600,easing:'ease-out'});
    },20);
  });
})();

/* 26/10/2026 (v10.1) MOTION #1: first gallery frame comes alive. The photo paints first (fast first screen);
   after the page has loaded the small silent loop loads and fades in over it. Plays only while on screen.
   Skipped for reduced motion and data-saver. */
(function(){
  var v=document.querySelector('.lv-frame__vid[data-lb-src]');if(!v)return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var save=navigator.connection&&navigator.connection.saveData;
  var slow=navigator.connection&&/(^|-)(2g|3g)$/.test(navigator.connection.effectiveType||'');
  if(reduce||save||slow)return;
  var started=false;
  function start(){
    if(started)return;started=true;
    v.src=v.getAttribute('data-lb-src');v.muted=true;v.preload='auto';
    v.addEventListener('playing',function(){v.classList.add('is-on');},{once:true});
    var p=v.play();if(p&&p.catch)p.catch(function(){});
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var q=v.play();if(q&&q.catch)q.catch(function(){});}else v.pause();});},{threshold:.35}).observe(v);}
  }
  /* 26/10/2026 v10.2 speed: the 0.8 MB loop starts on the first scroll/touch, or 6 s after load, never on 2G/3G */
  function kick(){['scroll','touchstart','pointerdown'].forEach(function(t){window.removeEventListener(t,kick,t!=='scroll');});start();}
  function later(){['scroll','touchstart','pointerdown'].forEach(function(t){window.addEventListener(t,kick,{capture:t!=='scroll',passive:true});});}
  if(document.readyState==='complete')later();else window.addEventListener('load',later);
})();

/* 26/10/2026 (v10.1) MOTION #4: drag along the spectrum bar. Each stop lights its label and row
   (PDP: Week 1 > Week 4 nails > Week 8 skin > Week 12 hair; home: creams > Lovu). Tap a label or row to jump. */
(function(){
  document.querySelectorAll('.lb-spec').forEach(function(sec){
    var bar=sec.querySelector('.lb-spec__bar'),rows=[].slice.call(sec.querySelectorAll('.lb-spec__row')),labels=[].slice.call(sec.querySelectorAll('.lb-spec__labels span'));
    if(!bar||rows.length<2)return;
    var n=rows.length,track=document.createElement('div');track.className='lb-spec__track';
    bar.parentNode.insertBefore(track,bar);track.appendChild(bar);
    var fill=document.createElement('span');fill.className='lb-spec__fill';bar.appendChild(fill);
    var r=document.createElement('input');r.type='range';r.className='lb-spec__slider';r.min=0;r.max=(n-1)*100;r.step=1;
    r.setAttribute('aria-label',(document.documentElement.lang||'').slice(0,2)==='ar'?'اسحبي للتنقل بين المراحل':'Drag to move along the stages');
    track.appendChild(r);
    var isPdp=/__research$/.test((sec.closest('.shopify-section')||{}).id||'');
    var isAr=(document.documentElement.lang||'').slice(0,2)==='ar';
    var hint=document.createElement('small');hint.className='lb-spec__hint';hint.textContent=isAr?(isPdp?'اسحبي النقطة: من الأسبوع 1 إلى الأسبوع 12':'اسحبي النقطة على الشريط'):(isPdp?'Drag the dot: week 1 to week 12':'Drag the dot along the bar');
    track.parentNode.insertBefore(hint,track.nextSibling);
    sec.classList.add('lb-spec--live');
    var cur=-1;
    function set(i,fromInput){
      i=Math.max(0,Math.min(n-1,i));
      if(!fromInput)r.value=i*100;
      fill.style.width=(r.value/((n-1)*100)*100)+'%';
      if(i===cur)return;cur=i;
      rows.forEach(function(x,k){x.classList.toggle('is-on',k===i);});
      labels.forEach(function(x,k){x.classList.toggle('is-on',k===i);});
      r.setAttribute('aria-valuetext',(labels[i]?labels[i].textContent:'')+' '+(rows[i].querySelector('b')||{}).textContent);
    }
    r.addEventListener('input',function(){set(Math.round(r.value/100),true);});
    r.addEventListener('change',function(){set(Math.round(r.value/100));});
    rows.forEach(function(x,k){x.addEventListener('click',function(){set(k);});});
    labels.forEach(function(x,k){x.addEventListener('click',function(){set(k);});});
    set(isPdp?0:n-1);
  });
})();

/* 26/10/2026 (v10.1) MOTION #5: tap or click an ingredient tile to flip it to its "what it does for you" line.
   Quick fake-3D turn (no layout shift); Enter/Space work too; off for reduced motion (instant swap). */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function flip(el){
    var to=!el.classList.contains('is-flipped');
    if(reduce){el.classList.toggle('is-flipped',to);el.setAttribute('aria-pressed',to);return;}
    if(el.__lbFlipping)return;el.__lbFlipping=true;
    /* timer-driven: the content swap happens even if animation frames are throttled */
    el.classList.add('lb-flip3--out');
    setTimeout(function(){
      el.classList.toggle('is-flipped',to);el.setAttribute('aria-pressed',to);
      el.classList.remove('lb-flip3--out');el.classList.add('lb-flip3--in');
      requestAnimationFrame(function(){requestAnimationFrame(function(){el.classList.remove('lb-flip3--in');});});
      setTimeout(function(){el.classList.remove('lb-flip3--in');el.__lbFlipping=false;},260);
    },170);
  }
  document.addEventListener('click',function(e){var el=e.target.closest&&e.target.closest('.lb-flip3');if(el)flip(el);});
  document.addEventListener('keydown',function(e){if(e.key!=='Enter'&&e.key!==' ')return;var el=e.target.closest&&e.target.closest('.lb-flip3');if(el){e.preventDefault();flip(el);}});
})();

/* 26/10/2026 (v10.1) MOTION #8: the before/after line sweeps once (50 > 35 > 65 > 50) the first time the slider
   is well on screen, so people see it can be dragged. Never repeats; stops the moment they touch it; off for reduced motion.
   Timer-driven (not animation frames) so it always ends back at 50. */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window))return;
  document.querySelectorAll('.lx-ba__view').forEach(function(view){
    var r=view.querySelector('.lx-ba__range');if(!r)return;
    var touched=false,done=false,timer=null;
    function setPos(p){r.value=p;view.style.setProperty('--pos',p+'%');}
    function stop(){touched=true;if(timer){clearInterval(timer);timer=null;}}
    ['pointerdown','touchstart','keydown'].forEach(function(ev){view.addEventListener(ev,stop,{passive:true});});
    var keys=[[0,50],[550,35],[1250,65],[1800,50]],t0;
    function ease(x){return x<.5?2*x*x:1-Math.pow(-2*x+2,2)/2;}
    function run(){
      if(done||touched)return;done=true;t0=Date.now();
      timer=setInterval(function(){
        var t=Date.now()-t0;
        if(t>=keys[keys.length-1][0]){setPos(50);clearInterval(timer);timer=null;return;}
        for(var i=1;i<keys.length;i++){if(t<=keys[i][0]){var a=keys[i-1],b=keys[i],k=ease((t-a[0])/(b[0]-a[0]));setPos(Math.round((a[1]+(b[1]-a[1])*k)*10)/10);break;}}
      },16);
    }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting&&e.intersectionRatio>=.6){io.disconnect();setTimeout(run,350);}});},{threshold:[0,.6]});
    io.observe(view);
  });
})();

/* 26/10/2026 v10.2 speed + CRO: on phones the sticky price + Add to bag bar shows whenever the main Add to bag is
   off screen, above OR below (it used to wait until you had scrolled past it, so a first-screen visitor saw no price). */
(function(){
  if(!('IntersectionObserver' in window))return;
  var bar=document.querySelector('.lx-sticky'),btn=document.querySelector('form [type=submit][name=add]');
  if(!bar||!btn)return;
  var mq=window.matchMedia('(max-width: 899px)');
  new IntersectionObserver(function(en){
    var show=mq.matches&&!en[0].isIntersecting;
    bar.classList.toggle('lx-sticky--early',show);
    document.body.classList.toggle('lx-sticky-early',show);
    setTimeout(function(){
      var vis=show||bar.classList.contains('is-on');
      bar.setAttribute('aria-hidden',vis?'false':'true');
      bar.querySelectorAll('a,button').forEach(function(el){el.tabIndex=vis?0:-1;});
    },0);
  }).observe(btn);
})();

/* 27/10/2026 v11: the main button names the chosen pack ("Add 2 jars to bag" · AED 340; "Subscribe monthly" · AED 169).
   lx.js resets the label to "Add to bag" on every pack change and restores the button after adding, so a watcher re-applies it.
   English pages only; other languages keep the theme's own label. */
(function(){
  if((document.documentElement.lang||'en').slice(0,2)!=='en')return;
  function init(){
    document.querySelectorAll('.lb-pdpb').forEach(function(pdp){
      var tiers=pdp.querySelector('[data-lx-tiers]'),form=pdp.querySelector('form[data-lx-pform]');
      if(!tiers||!form)return;
      var btn=form.querySelector('[type=submit][name=add]');if(!btn)return;
      var busy=false;
      function want(){var on=tiers.querySelector('input:checked');if(!on)return null;var n=(on.getAttribute('data-n')||'').trim();if(!n)return null;
        if(on.getAttribute('data-plan'))return n;return /jar/i.test(n)?'Add '+n+' to bag':null;}
      function apply(){var on=tiers.querySelector('input:checked');var nm=on?(on.getAttribute('data-n')||''):'';document.querySelectorAll('[data-lx-sticky-name]').forEach(function(e){if(e.textContent!==nm)e.textContent=nm;});
        if(busy||btn.disabled)return;var l=btn.querySelector('[data-lx-btnl]');var w=want();if(!l||!w)return;if(l.textContent!==w){busy=true;l.textContent=w;busy=false;}}
      tiers.addEventListener('change',function(){setTimeout(apply,0);});
      new MutationObserver(function(){if(!busy)setTimeout(apply,0);}).observe(btn,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled']});
      apply();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* 27/10/2026 v11: the full Judge.me list starts with 3 reviews and a "Show all reviews" button (the list was ~3,200px on phones). */
(function(){
  var root=document.getElementById('judgeme_product_reviews');if(!root)return;
  var opened=false;
  function setup(){
    if(opened)return;
    var items=root.querySelectorAll('.jm-review-item, .jdgm-rev');if(items.length<4)return;
    if(root.querySelector('.lb-jm-more'))return;
    root.classList.add('lb-jm-short');
    var b=document.createElement('button');b.type='button';b.className='lb-jm-more';
    var total=(root.querySelector('[data-number-of-reviews]')||{}).getAttribute?root.querySelector('[data-number-of-reviews]').getAttribute('data-number-of-reviews'):'';
    var ar=(document.documentElement.lang||'').slice(0,2)==='ar';
    b.textContent=ar?(total?'عرض كل التقييمات ('+total+')':'عرض كل التقييمات'):(total?'Show all '+total+' reviews':'Show all reviews');
    b.addEventListener('click',function(){opened=true;root.classList.remove('lb-jm-short');b.remove();mo.disconnect();});
    var list=items[items.length-1].parentNode;list.parentNode.insertBefore(b,list.nextSibling);
  }
  var mo=new MutationObserver(setup);mo.observe(root,{childList:true,subtree:true});setup();
})();
